/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import React, { useEffect, useState } from 'react';
import { camelCase, uniqueId } from "lodash";

import { ResponsiveTable, CheckBox, Label } from '@fitinsur/components';
import { PartysSection } from '../index';

function RenderSection({
  disableAll,
  formikProps,
  formikRef,
  idProduct,
  idOperation,
  idOperationParent,
  globalQuestionnaire,
  setQuestionnaire
}) {
  const [columns, setColomns] = useState([]);
  const [dataTable, setDataTable] = useState([]);


  const getOption = (answerOption) => {
    return {
      label: answerOption.dsAnswerOption,
      value: {
        idAnswerOption: answerOption.idAnswerOption,
        dsAnswerOption: answerOption.dsAnswerOption
      }
    }
  }

  const getComponent = (qst) => {
    return qst.idQuestion === 2046
      ? (listItem) => <Label>{listItem[qst.key].dsAnswerOption}</Label>
      : (listItem) => <CheckBox
        key={qst.key}
        value={getOption(listItem[qst.key])}
        name={qst.key}
        fieldError={formikRef.current?.errors[qst.key]}
        checked={PartysSection.events.handleChecked(listItem[qst.key], formikRef)}
        onChange={() => !disableAll && PartysSection.events.handleSelect({
          value: listItem[qst.key],
          key: qst.key,
          setQuestionnaire,
          globalQuestionnaire,
          formikRef
        })}
      />
  }

  useEffect(() => {
    const sectionQuestionnaire = globalQuestionnaire.filter(qst => qst.behaviorObject?.sectionName === "PARTYS");
    const { setFieldValue } = formikRef.current;
    if (setFieldValue) {
      setFieldValue('$ANSWERS_PARTYS', sectionQuestionnaire);
    }
  }, [globalQuestionnaire]);


  useEffect(() => {
    const qstLabels = globalQuestionnaire.filter(qst => [2046, 136, 137, 138, 167].includes(qst.idQuestion));
    let data = [];
    const colls = qstLabels.map((qst, index) => {
      if (!qst.key) {
        qst.key = `${camelCase(qst.dsQuestion)}_${qst.idQuestion}_${uniqueId()}`;
      }

      PartysSection.events.getQuestionAnswer(qst, formikRef.current?.setFieldValue);

      let col = {
        title: `${qst.behaviorObject?.isRequired ? '* ' : ''} ${qst.dsQuestion}`,
        key: qst.key,
        error: !!(formikRef.current?.errors[qst.key]),
        minWidth: qst.idQuestion === 2046 ? 15 : 8,
        maxWidth: qst.idQuestion === 2046 ? 15 : 8,
        component: getComponent(qst)
      };

      /* constructing the object row for table with options from every party question */
      qst.answerOptions.forEach((opt, index) => {
        typeof data[index] === 'object' /* if a object row already exists then includes info */
          ? Object.assign(data[index], { [qst.key]: { ...opt, key: qst.key } })
          : data[index] = { [qst.key]: { ...opt, key: qst.key } };
      });
      return col;
    })
    setColomns(colls);
    setDataTable(data);
  }, [globalQuestionnaire, formikRef.current?.errors]);

  return (
    <ResponsiveTable
      formikRef
      columns={columns}
      data={dataTable}
    />
  )
}

const components = {
  RenderSection
}

export { components }